import classNames from 'classnames';
import React, { FC } from 'react';

import { CosmosComponent } from '../../../types';
import { Variant } from '../ButtonDeprecated';

import styles from './SpinnerDeprecated.module.css';

type SpinnerSizes = 'small' | 'big' | 'medium';

export interface SpinnerDeprecatedProps extends CosmosComponent {
  size?: SpinnerSizes;
  variant?: Variant;
}

export const SpinnerDeprecated: FC<SpinnerDeprecatedProps> = ({
  className,
  size = 'big',
  variant = 'primary',
  isInverted,
  testId,
}) => (
  <div
    className={classNames(
      className,
      styles.Spinner,
      styles[size],
      styles[variant],
      {
        [styles.inverted]: isInverted,
      },
    )}
    data-test-id={testId}
  />
);
